<template>
  <div class="contentArea">
    <AgGrid />
  </div>
</template>

<script>
import AgGrid from "../elements/ag-grid-table/AgGridTable.vue";
export default {
  components: {
    AgGrid
  },
  async mounted() {
    await this.$store.dispatch("general/get_paymentTable");
    this.$store.dispatch("general/push_pointer", "payment");
  }
};
</script>

<style lang="scss" scoped></style>
